/* istanbul ignore file */
import { FormRow } from 'framework/ui/layout';
import useAccessLogService from 'domain/people/employee/AccessLog/accessLogService';
import { DateInput, CreateForm, SubmitFormButton } from 'framework/form';
import AccessLogManual from 'domain/people/employee/AccessLog/AccessLogManual';

const AccessLogPage = () => {
  const { getValidationSchema, requestLogCsv } = useAccessLogService();

  const onFormResponseForm = (response: any) => {
    const contentDisposition = response.headers.get('content-disposition');
    response.blob().then((blob: Blob | MediaSource) => {
      const objectUrl = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = objectUrl;
      // eslint-disable-next-line prefer-destructuring
      anchor.download = /filename="(.*)"/g.exec(contentDisposition)![1];
      anchor.click();
      window.URL.revokeObjectURL(objectUrl);
    });
  };
  return (
    <>
      <CreateForm
        submitFormFunc={data => requestLogCsv(data.dateFrom, data.dateTo)}
        afterSubmit={{ execute: data => onFormResponseForm(data) }}
        getValidationSchemaFunc={getValidationSchema}
      >
        <FormRow>
          <DateInput label="Start date" source="dateFrom" />
          <DateInput label="End date" source="dateTo" />
        </FormRow>
        <SubmitFormButton>DOWNLOAD</SubmitFormButton>
      </CreateForm>
      <AccessLogManual />
    </>
  );
};

export default AccessLogPage;
